import { render } from "./Text.vue?vue&type=template&id=cea40cb6&scoped=true"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import "./Text.vue?vue&type=style&index=0&id=cea40cb6&lang=scss&scoped=true"

import exportComponent from "/app/tmp/bambl/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea40cb6"]])

export default __exports__